import React, { useState, useEffect } from 'react'
import Icons from '../../Constants/Icons'

const imageArray = [Icons.bg117, Icons.bg118, Icons.bg119]

const CustomSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  // Auto-slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % imageArray.length)
    }, 3000)
    return () => clearInterval(interval)
  }, [])

  return (
    <section
      className='vc_row bg-cover'
      style={{ position: 'relative', height: '400px', overflow: 'hidden' }}
    >
      {imageArray.map((image, index) => (
        <div
          key={index}
          className='slide'
          style={{
            backgroundImage: `url(${image})`,
            opacity: index === currentIndex ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
      ))}
    </section>
  )
}

export default CustomSlider
